import React from 'react';
import Image from 'next/image';

export function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-struvital-light to-struvital-dark flex items-center justify-center">
      <div className="text-center">
        <div className="flex justify-center mb-6">
          <Image
            src="/struvital-logo.png"
            alt="Struvital"
            width={200}
            height={80}
            priority
            className="h-20 w-auto animate-pulse"
          />
        </div>
        <div className="flex justify-center mb-4">
          <svg className="animate-spin h-8 w-8 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
        <p className="text-white text-lg">Loading Dashboard...</p>
      </div>
    </div>
  );
}